import React, { useRef, useEffect } from 'react';
import './BakeryHero.css';

const BakeryHero = () => {
  const videoRef = useRef(null);

  // Lazy-load autoplay with IntersectionObserver
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && videoRef.current && videoRef.current.paused) {
          videoRef.current.play().catch(() => {}); // ignore autoplay errors
        }
      },
      { threshold: 0.5 }
    );
    if (videoRef.current) observer.observe(videoRef.current);
    return () => observer.disconnect();
  }, []);

  const togglePlayback = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play().catch(() => {}); // ignore autoplay restrictions
    } else {
      video.pause();
    }
  };
//https://res.cloudinary.com/dqqoti4er/video/upload/v1746636866/pablitostacos_1733506568_3517229960337675345_9383903430_pymuhu.mp4
  return (
    <div className="hero-container">
      <video
        ref={videoRef}
        muted
        loop
        playsInline
        preload="none"
        className="hero-video"
        onClick={togglePlayback}
      >
        <source
          src="https://res.cloudinary.com/dqqoti4er/video/upload/c_crop,w_1000,h_1000,g_north/v1746636866/pablitostacos_1733506568_3517229960337675345_9383903430_pymuhu.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      <div className="hero-text">
        <h1>Pablito's Tacos</h1>
        <p>Street Tacos · Smash Burgers · Pizza · Rotiesserie</p>
      </div>

      <button
        className="hero-toggle-button"
        onClick={togglePlayback}
        aria-label="Toggle video"
      >
        ❚❚
      </button>
    </div>
  );
};

export default BakeryHero;